import { Auth } from 'aws-amplify';

export default async (level) => {
  const userInfo = await Auth.currentUserInfo();
  if (level === 'private' || level === 'protected') {
    return `${`${level}/${userInfo.id}`}`;
  }
  return 'public';
};
